import styled from "styled-components";
import { FlexBox, GridBox } from "@brg/ui";
import { LayoutConst } from "core/modules";

interface IProps {
    isMobile?: boolean;
    pt?: string;
}

export const JuryHeader = styled(FlexBox)<IProps>`
    padding: ${p => p.isMobile ? "0px 0 24px 0" : "0px 0 40px 0"};
    width: 100%;
    margin: 0 auto;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 90%
    }
   
`;

export const JuryContent = styled(JuryHeader)<IProps>`
    justify-content: flex-end;
    padding: ${p => p.isMobile ? "48px 40px 48px 0" : " 48px 48px 48px 0"};
`;

export const JuryCardsWrapper = styled(GridBox)<IProps>`
    grid-template-columns: repeat(4, minmax(0, 1fr));
    justify-items: center;
    gap: 24px;
    margin-top: 24px;

    // @media(max-width: ${LayoutConst.screen.l_12}px) {
    //     grid-template-columns: repeat(3, 1fr);
    // }

    @media(max-width: ${LayoutConst.screen.md}px) {
        grid-template-columns: repeat(4, calc(25% - 12px));
        grid-template-rows: auto;
        padding: ${p => p?.pt ? `${p?.pt}px` :'24px'} 0 48px 0;
        margin: 0 auto;
        width: 100%;
        gap: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        grid-template-columns: repeat(2, calc(50% - 5px));
        gap: 10px;
    }

    // @media(max-width: 576px) {
    //     grid-template-columns: repeat(2, 1fr);
    //     width: 100%;
    //     gap: 10px;
    // }
    // @media(max-width: 320px) {
    //     grid-template-columns: repeat(2, 145px);
    //     width: 100%;
    //     gap: 10px;
    // }
`;
import styled from "styled-components";
import { FlexBox, GridBox } from "@brg/ui";
import { LayoutConst } from "core/modules";

interface IProps {
    isMobile?: boolean;
    pt?: string;
}

export const JuryHeader = styled(FlexBox)<IProps>`
    padding: ${p => p.isMobile ? "0px 0 24px 0" : "0px 0 40px 0"};
    width: 100%;
    margin: 0 auto;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 90%
    }
   
`;

export const JuryContent = styled(JuryHeader)<IProps>`
    justify-content: flex-end;
    padding: ${p => p.isMobile ? "48px 40px 48px 0" : " 48px 48px 48px 0"};
`;

export const JuryCardsWrapper = styled(GridBox)<IProps>`
    grid-template-columns: repeat(4, minmax(0, 1fr));
    justify-items: center;
    gap: 24px;
    margin-top: 24px;

    // @media(max-width: ${LayoutConst.screen.l_12}px) {
    //     grid-template-columns: repeat(3, 1fr);
    // }

    @media(max-width: ${LayoutConst.screen.md}px) {
        grid-template-columns: repeat(4, calc(25% - 12px));
        grid-template-rows: auto;
        padding: ${p => p?.pt ? `${p?.pt}px` :'24px'} 0 48px 0;
        margin: 0 auto;
        width: 100%;
        gap: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        grid-template-columns: repeat(2, calc(50% - 5px));
        gap: 10px;
    }

    // @media(max-width: 576px) {
    //     grid-template-columns: repeat(2, 1fr);
    //     width: 100%;
    //     gap: 10px;
    // }
    // @media(max-width: 320px) {
    //     grid-template-columns: repeat(2, 145px);
    //     width: 100%;
    //     gap: 10px;
    // }
`;
